up.compiler('[data-focus-on-anchor]', (element) => {
  function focusIfAnchorMatches() {
    if (window.location.hash === element.getAttribute('data-focus-on-anchor')) {
      const firstInput = element.querySelector<HTMLInputElement | HTMLSelectElement>(
        'input:not([type="hidden"]), select:not([type="hidden"])',
      )
      if (firstInput) {
        setTimeout(() => {
          firstInput.focus()
        }, 0)
      }
    }
  }

  focusIfAnchorMatches()

  return up.on('hashchange', focusIfAnchorMatches)
})
